module.exports = __webpack_public_path__ + "static/media/bg_community.83b6660b.png";